<div class="accordion-block" [class]="customCss()">
  @if (isEditable()) {
    <div class="add-panel-row" contenteditable="false">
      <span class="add-panel-btn" (click)="addPanel()" dojoStopPropagation>+ Add panel</span>
    </div>
  }

  <div tiptapNodeViewContent></div>
</div>
